export const categories = [
  {
    slug: 'zixun-meiti',
    name: '资讯媒体',
    icon: 'ri-newspaper-line',
    description: '汇聚最新资讯与权威媒体平台，实时掌握行业动态与热点新闻',
    links: [
      { name: '新浪新闻', url: 'https://news.sina.com.cn', description: '综合性新闻门户网站，提供全方位新闻报道' },
      { name: '腾讯新闻', url: 'https://news.qq.com', description: '事实派新闻资讯平台，深度报道与独家策划' },
      { name: '网易新闻', url: 'https://news.163.com', description: '有态度的新闻门户，深度原创内容平台' },
      { name: '搜狐新闻', url: 'https://news.sohu.com', description: '权威新闻资讯聚合平台，24小时滚动更新' },
      { name: '澎湃新闻', url: 'https://www.thepaper.cn', description: '专注时政与思想的互联网新闻平台' },
      { name: '界面新闻', url: 'https://www.jiemian.com', description: '中国具有影响力的原创财经新媒体' },
      { name: '36氪', url: 'https://36kr.com', description: '专注科技创投领域的新商业媒体' },
      { name: '虎嗅网', url: 'https://www.huxiu.com', description: '聚合优质创新信息与人群的新媒体平台' },
    ],
  },
  {
    slug: 'sousuo-yinqing',
    name: '搜索引擎',
    icon: 'ri-search-eye-line',
    description: '全球主流搜索引擎入口，快速精准获取所需信息',
    links: [
      { name: '百度搜索', url: 'https://www.baidu.com', description: '全球最大的中文搜索引擎' },
      { name: '谷歌搜索', url: 'https://www.google.com', description: '全球领先的搜索引擎，信息覆盖最广' },
      { name: '必应搜索', url: 'https://www.bing.com', description: '微软旗下国际搜索引擎，集成AI智能问答' },
      { name: '搜狗搜索', url: 'https://www.sogou.com', description: '支持微信与知乎内容搜索的中文搜索引擎' },
      { name: '360搜索', url: 'https://www.so.com', description: '安全绿色的综合搜索引擎' },
      { name: '神马搜索', url: 'https://m.sm.cn', description: 'UC浏览器旗下的移动端搜索引擎' },
    ],
  },
  {
    slug: 'shejiao-pingtai',
    name: '社交平台',
    icon: 'ri-chat-smile-2-line',
    description: '主流社交媒体与社区平台，连接人与信息、人与人的互动空间',
    links: [
      { name: '微信', url: 'https://weixin.qq.com', description: '腾讯旗下即时通讯与社交平台，月活超13亿' },
      { name: '微博', url: 'https://weibo.com', description: '中国领先的社交媒体平台，热点话题聚集地' },
      { name: '知乎', url: 'https://www.zhihu.com', description: '高质量问答社区，连接各行各业的专业知识人群' },
      { name: '豆瓣', url: 'https://www.douban.com', description: '精神角落，书影音分享与评论社区' },
      { name: '小红书', url: 'https://www.xiaohongshu.com', description: '生活方式分享平台，引领消费决策' },
      { name: '抖音', url: 'https://www.douyin.com', description: '短视频社交平台，记录美好生活' },
    ],
  },
  {
    slug: 'dianshang-gouwu',
    name: '电商购物',
    icon: 'ri-shopping-bag-3-line',
    description: '主流电商与购物平台，满足您一站式在线消费需求',
    links: [
      { name: '淘宝网', url: 'https://www.taobao.com', description: '阿里巴巴旗下C2C电商平台，万能的淘宝' },
      { name: '京东商城', url: 'https://www.jd.com', description: '正品保障的综合网购平台，自建物流配送' },
      { name: '拼多多', url: 'https://www.pinduoduo.com', description: '新电商开创者，社交拼团购物平台' },
      { name: '天猫商城', url: 'https://www.tmall.com', description: '品牌官方直营B2C购物平台' },
      { name: '苏宁易购', url: 'https://www.suning.com', description: '全品类综合电商平台，线上线下融合' },
      { name: '唯品会', url: 'https://www.vip.com', description: '品牌特卖电商平台，每日精选折扣好物' },
    ],
  },
  {
    slug: 'xuexi-jiaoyu',
    name: '学习教育',
    icon: 'ri-book-open-line',
    description: '优质在线学习资源与教育平台，助力个人成长与技能提升',
    links: [
      { name: '中国大学MOOC', url: 'https://www.icourse163.org', description: '国内优质MOOC学习平台，汇集名校课程' },
      { name: '学堂在线', url: 'https://www.xuetangx.com', description: '清华大学发起的精品中文慕课平台' },
      { name: '网易公开课', url: 'https://open.163.com', description: '国内外名校公开课与TED演讲中文翻译' },
      { name: '哔哩哔哩', url: 'https://www.bilibili.com', description: '年轻人文化社区，海量学习资源与知识分享' },
      { name: '得到', url: 'https://www.dedao.cn', description: '知识服务平台，提供省时间的高效知识服务' },
      { name: '极客时间', url: 'https://time.geekbang.org', description: 'IT技术知识服务平台，助力技术人成长' },
    ],
  },
  {
    slug: 'gongju-yingyong',
    name: '工具应用',
    icon: 'ri-tools-line',
    description: '高效实用的在线工具与生产力应用，提升工作与生活效率',
    links: [
      { name: '石墨文档', url: 'https://shimo.im', description: '多人实时协作的在线文档与表格工具' },
      { name: 'ProcessOn', url: 'https://www.processon.com', description: '免费在线流程图、思维导图制作工具' },
      { name: 'Canva可画', url: 'https://www.canva.cn', description: '在线平面设计工具，轻松制作海报与社交媒体图片' },
      { name: '腾讯文档', url: 'https://docs.qq.com', description: '支持多人协作的免费在线办公套件' },
      { name: '幕布', url: 'https://mubu.com', description: '极简大纲笔记与思维导图工具' },
      { name: 'Notion', url: 'https://www.notion.so', description: '全能型笔记与知识管理工具' },
    ],
  },
  {
    slug: 'yingshi-yinle',
    name: '影视音乐',
    icon: 'ri-film-line',
    description: '热门影视、综艺节目与音乐平台，畅享视听娱乐盛宴',
    links: [
      { name: '爱奇艺', url: 'https://www.iqiyi.com', description: '高品质视频娱乐服务，海量正版高清影视' },
      { name: '腾讯视频', url: 'https://v.qq.com', description: '中国领先的在线视频媒体平台' },
      { name: '优酷', url: 'https://www.youku.com', description: '阿里巴巴旗下视频平台，热门剧集综艺全覆盖' },
      { name: 'B站', url: 'https://www.bilibili.com', description: '国内知名的视频弹幕网站，ACG文化聚集地' },
      { name: '网易云音乐', url: 'https://music.163.com', description: '专注于发现与分享的音乐产品' },
      { name: 'QQ音乐', url: 'https://y.qq.com', description: '腾讯旗下正版数字音乐服务平台' },
    ],
  },
  {
    slug: 'shenghuo-fuwu',
    name: '生活服务',
    icon: 'ri-home-smile-line',
    description: '覆盖衣食住行的生活服务类平台，让生活更加便捷美好',
    links: [
      { name: '美团', url: 'https://www.meituan.com', description: '吃喝玩乐全都有，一站式生活服务平台' },
      { name: '大众点评', url: 'https://www.dianping.com', description: '城市生活消费指南，发现品质好店' },
      { name: '携程旅行', url: 'https://www.ctrip.com', description: '全球领先的在线旅游服务平台' },
      { name: '饿了么', url: 'https://www.ele.me', description: '在线外卖订餐平台，即时配送' },
      { name: '贝壳找房', url: 'https://www.ke.com', description: '技术驱动的品质居住服务平台' },
      { name: '高德地图', url: 'https://www.amap.com', description: '专业手机地图导航，吃喝玩乐尽在掌握' },
    ],
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((cat) => cat.slug === slug) || null;
};

export const getAllCategorySlugs = () => {
  return categories.map((cat) => cat.slug);
};